import React, { useEffect, useState } from "react";

const InstallAppBtn = () => {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [visible, setVisible] = useState(true);
  const [installed, setInstalled] = useState(false);

  useEffect(() => {
    // detect if already in standalone mode
    const isStandalone =
      window.matchMedia && window.matchMedia("(display-mode: standalone)").matches;
    if (window.navigator.standalone || isStandalone) {
      setInstalled(true);
      return;
    }

    const onBeforeInstall = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
      setVisible(true);
    };

    const onAppInstalled = () => {
      setInstalled(true);
      setVisible(false);
      setDeferredPrompt(null);
    };

    window.addEventListener("beforeinstallprompt", onBeforeInstall);
    window.addEventListener("appinstalled", onAppInstalled);

    return () => {
      window.removeEventListener("beforeinstallprompt", onBeforeInstall);
      window.removeEventListener("appinstalled", onAppInstalled);
    };
  }, []);

  const handleInstallClick = async () => {
    if (!deferredPrompt) {
      // fallback: show short instruction or open manifest link
      alert("Install is not available on this browser. Use your browser menu to 'Install' or 'Add to Home screen'.");
      return;
    }

    deferredPrompt.prompt();
    const choice = await deferredPrompt.userChoice;
    if (choice.outcome === "accepted") {
      setVisible(false);
      setDeferredPrompt(null);
    } else {
      // user dismissed
    }
  };

  if (!visible || installed) return null;

  return (
    <button
      className="install-app-btn"
      onClick={handleInstallClick}
      aria-label="Install Asakaa Play"
      title="Install Asakaa Play"
    >
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden>
        <path d="M12 3v10" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M5 12l7-7 7 7" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M21 21H3" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
      <span>Install App</span>
    </button>
  );
};

export default InstallAppBtn;
